import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';
import Image from 'next/image';
import { User } from 'firebase/auth';

import { HeaderLocales } from '@/src/components/header/HeaderLocales/HeaderLocales';
import { HeaderDownload } from '@/src/components/header/HeaderDownload/HeaderDownload';
import { HeaderAccount } from '@/src/components/header/HeaderAccount/HeaderAccount';
import { IResolvedHeader } from '@/src/utils/collections/header.mapper';

interface IProps {
  header: IResolvedHeader;
  locale: string;
  user: User | null;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export const HeaderMobile = ({
  header,
  locale,
  user,
  open,
  setOpen,
}: IProps) => {
  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        type="button"
        className="inline-flex size-10 justify-end self-end p-2 text-sm text-white lg:hidden"
      >
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {open ? (
            <path
              d="M24 2L8 17.3M24 17.3L8 2"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
            />
          ) : (
            <path
              stroke="white"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M7 1h18M7 9h18M7 17h18"
            />
          )}
        </svg>
      </button>
      {open && (
        <div
          className={
            'no-scrollbar fixed inset-x-0 bottom-0 top-16 z-10 h-[calc(100dvh-64px)] overflow-y-scroll bg-primary px-6 py-4 pt-8'
          }
        >
          <ul className="flex list-none flex-col gap-12">
            {header.items.map(link => (
              <li key={link.name + 'mobile'}>
                <Link
                  href={link.url}
                  onClick={() => {
                    setOpen(false);
                    window.dataLayer?.push({
                      event: 'click_button',
                      click_id: link.url,
                      click_label: link.name,
                    });
                  }}
                  className="flex text-2xl font-semibold text-white no-underline lg:text-base"
                >
                  {link.icon && (
                    <Image
                      className={'mr-2 mt-1'}
                      src={link.icon.icon}
                      alt={link.icon.alt || ''}
                      width={24}
                      height={24}
                    />
                  )}
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
          <div className={'mt-8 flex flex-col gap-6'}>
            <HeaderLocales
              setOpen={setOpen}
              locale={locale}
              localeList={header.locales}
              buttonLanguage={header.buttonLanguage}
            />
            <HeaderDownload
              className={'bg-white text-primary'}
              text={header.buttonDownload}
              linkToAppStore={header.linkToAppStore}
              linkToPlayStore={header.linkToPlayStore}
            />
            <HeaderAccount
              signInTranslation={header.buttonSignIn}
              signOutTranslation={header.buttonSignOut}
              user={user}
              setOpen={setOpen}
              locale={locale}
            />
          </div>
        </div>
      )}
    </>
  );
};
